import 'react-native-gesture-handler';
import react, { useCallback, useState, useEffect } from 'react';
import { Image, Text, View, TouchableOpacity, SafeAreaView } from 'react-native';
import WebView from 'react-native-webview';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { useTranslation } from 'react-i18next';
import { i18n } from './assets/lang/i18next';

import Dashboard from './pages/Dashboard';
import StartPage from './StartPage'
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import GalleryDetail from './pages/GalleryDetail';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import Profile from './pages/Profile';
import Request from './pages/Request';
import CustomerVoice from './pages/CustomerVoice';
import * as Font from 'expo-font';
import SelectDevice from './pages/SelectDevice';
import AppLoading from 'expo-app-loading';
import BorodatiPro from './pages/BorodatiPro';
import BorodatiResult from './pages/BorodatiResult';
import EvapratorByCalculate from './pages/Devices/Evaprator/Evaprator_By_Calculate';
import EvapratorByComp from './pages/Devices/Evaprator/Evaprator_By_Comp';
import CondO45ByComp from './pages/Devices/Evaprator/CondO45_By_Comp';
import CondO45ByCalculate from './pages/Devices/Evaprator/CondO45_By_Calculate';
import CondA45ByComp from './pages/Devices/Evaprator/CondA45_By_Comp';
import CondA45ByCalculate from './pages/Devices/Evaprator/CondA45_By_Calculate';
import EvapratorArtecByCalculate from './pages/Devices/Evaprator/EvapratorArtec_By_Calculate';
import EvapratorArtecByComp from './pages/Devices/Evaprator/EvapratorArtec_By_Comp';
import CondO8ByCalculate from './pages/Devices/Evaprator/CondO8_By_Calculate';
import CondA8ByCalculate from './pages/Devices/Evaprator/CondA8_By_Calculate';
import CondArtecByCalculate from './pages/Devices/Evaprator/CondArtec_By_Calculate';
import CondAtecByComp from './pages/Devices/Evaprator/CondArtec_By_Comp';
import { createDrawerNavigator } from '@react-navigation/drawer';
import Projects from './pages/Projects';
import Gallery from './pages/Gallery';
import LiveChat from './pages/LiveChat';
import BorodatiSimple from './pages/BorodatiSimple';
import ResultBorodatiSimple from './pages/ResultBorodatiSimple';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import SelectDevice_EvapratorChandMedareh from './pages/Devices/Evaprator/Evaprator_ChandMedareh';
import ResultEvaprator from './pages/Devices/Evaprator/Result_Evaprator';
import ResultCondenser from './pages/Devices/Evaprator/Result_Condenser';
import Search_Evaprator from './pages/Devices/Evaprator/Search_Evaprator'
import Home from './pages/Home';
import Icon from 'react-native-vector-icons/FontAwesome';
import MenuNav from './pages/MenuNav';

import useInternetStatus from './Components/useInternetStatus';
import { padding } from '@mui/system';
import { color } from 'react-native-reanimated';
import CompEvaprator from './pages/Comparison_Evaprator';
import CompCondonser from './pages/Comparison_Condonser';
import * as SplashScreen from 'expo-splash-screen';


const Stack = createStackNavigator();
const Drawer = createDrawerNavigator();
const Tab = createBottomTabNavigator();
const Tab_Select_Evaprator = createBottomTabNavigator();
const Tab_Select_EvapratorArtec = createBottomTabNavigator();
const Tab_Select_CondO45 = createBottomTabNavigator();


const BorodatiSimpleTab = () => {
  return (
    <Tab.Navigator screenOptions={{
      headerShown: false,
      tabBarLabelPosition: 'beside-icon',
      tabBarActiveTintColor: '#d12023',
      tabBarStyle: {
        backgroundColor: '#e6e6e6',
      },
      tabBarLabelStyle: {
        fontFamily: 'IranSans',
        fontSize: 14,
      },
      tabBarIconStyle: { display: "none" },
      tabBarItemStyle: {
        backgroundColor: '#fff',
        margin: 5,
        borderRadius: 10,
      }
    }} >
      <Tab.Screen name='BorodatiSimple' component={BorodatiSimple} options={{ tabBarLabel: 'محاسبه ساده' }} />
      <Tab.Screen name='BorodatiPro' component={BorodatiPro} options={{ tabBarLabel: 'محاسبه پیشرفته' }} />
    </Tab.Navigator>
  )
}
const SelectDevice_Evaprator = () => {
  const { t, i18n } = useTranslation();

  return (
    <Tab_Select_Evaprator.Navigator screenOptions={{
      headerShown: false,
      tabBarActiveTintColor: '#d12023',
      tabBarLabelPosition: 'beside-icon',
      tabBarStyle: {
        backgroundColor: '#e6e6e6',
      },
      tabBarLabelStyle: {
        fontFamily: 'IranSans',
        fontSize: 13.5,
      },
      tabBarIconStyle: { display: "none" },
      tabBarItemStyle: {
        backgroundColor: '#fff',
        margin: 5,
        borderRadius: 10,
      }
    }} >
      <Tab_Select_Evaprator.Screen name='EvapratorCalculate' component={EvapratorByCalculate} options={{ tabBarLabel: t('basedoncalculation') }} />
      <Tab_Select_Evaprator.Screen name='EvapratorComp' component={EvapratorByComp} options={{ tabBarLabel: t('basedoncompressor') }} />
    </Tab_Select_Evaprator.Navigator>
  )
}
const SelectDevice_EvapratorArtec = () => {
  const { t, i18n } = useTranslation();

  return (
    <Tab_Select_EvapratorArtec.Navigator screenOptions={{
      headerShown: false,
      tabBarLabelPosition: 'beside-icon',
      tabBarActiveTintColor: '#d12023',
      tabBarStyle: {
        backgroundColor: '#e6e6e6',
      },
      tabBarLabelStyle: {
        fontFamily: 'IranSans',
        fontSize: 14,
      },
      tabBarIconStyle: { display: "none" },
      tabBarItemStyle: {
        backgroundColor: '#fff',
        margin: 5,
        borderRadius: 10,
      }
    }} >
      <Tab_Select_EvapratorArtec.Screen name='EvapratorCalculate' component={EvapratorArtecByCalculate} options={{ tabBarLabel: t('basedoncalculation') }} />
      <Tab_Select_EvapratorArtec.Screen name='EvapratorComp' component={EvapratorArtecByComp} options={{ tabBarLabel: t('basedoncompressor') }} />
    </Tab_Select_EvapratorArtec.Navigator>
  )
}
const SelectDevice_CondO45 = () => {
  const { t, i18n } = useTranslation();

  return (
    <Tab_Select_CondO45.Navigator screenOptions={{
      headerShown: false,
      tabBarLabelPosition: 'beside-icon',
      tabBarActiveTintColor: '#d12023',
      tabBarStyle: {
        backgroundColor: '#e6e6e6',
      },
      tabBarLabelStyle: {
        fontFamily: 'IranSans',
        fontSize: 14,
      },
      tabBarIconStyle: { display: "none" },
      tabBarItemStyle: {
        backgroundColor: '#fff',
        margin: 5,
        borderRadius: 10,
      }
    }} >
      <Tab_Select_CondO45.Screen name='CondO45Calculate' component={CondO45ByCalculate} options={{ tabBarLabel: t('basedoncalculation') }} />
      <Tab_Select_CondO45.Screen name='CondO45Comp' component={CondO45ByComp} options={{ tabBarLabel: t('basedoncompressor') }} />
    </Tab_Select_CondO45.Navigator>
  )
}
const SelectDevice_CondA45 = () => {
  const { t, i18n } = useTranslation();
  return (
    <Tab_Select_CondO45.Navigator screenOptions={{
      headerShown: false,
      tabBarLabelPosition: 'beside-icon',
      tabBarActiveTintColor: '#d12023',
      tabBarStyle: {
        backgroundColor: '#e6e6e6',
      },
      tabBarLabelStyle: {
        fontFamily: 'IranSans',
        fontSize: 14,
      },
      tabBarIconStyle: { display: "none" },
      tabBarItemStyle: {
        backgroundColor: '#fff',
        margin: 5,
        borderRadius: 10,
      }
    }} >
      <Tab_Select_CondO45.Screen name='CondA45Calculate' component={CondA45ByCalculate} options={{ tabBarLabel: t('basedoncalculation') }} />
      <Tab_Select_CondO45.Screen name='CondA45Comp' component={CondA45ByComp} options={{ tabBarLabel: t('basedoncompressor') }} />
    </Tab_Select_CondO45.Navigator>
  )
}
const SelectDevice_CondArtec = () => {
  const { t, i18n } = useTranslation();

  return (
    <Tab_Select_CondO45.Navigator screenOptions={{
      headerShown: false,
      tabBarLabelPosition: 'beside-icon',
      tabBarActiveTintColor: '#d12023',
      tabBarStyle: {
        backgroundColor: '#e6e6e6',
      },
      tabBarLabelStyle: {
        fontFamily: 'IranSans',
        fontSize: 14,
      },
      tabBarIconStyle: { display: "none" },
      tabBarItemStyle: {
        backgroundColor: '#fff',
        margin: 5,
        borderRadius: 10,
      }
    }} >
      <Tab_Select_CondO45.Screen name='CondO45Calculate' component={CondArtecByCalculate} options={{ tabBarLabel: t('basedoncalculation') }} />
      <Tab_Select_CondO45.Screen name='CondO45Comp' component={CondAtecByComp} options={{ tabBarLabel: t('basedoncompressor') }} />
    </Tab_Select_CondO45.Navigator>
  )
}

const TabBtnNav = createBottomTabNavigator();
const TabBottomFunc = () => {
  const { t, i18n } = useTranslation();
  return (
    <TabBtnNav.Navigator
      screenOptions={{
        tabBarActiveTintColor: "gray",
        tabBarInactiveTintColor: '#fff',
        headerShown: false,
        tabBarLabelPosition: 'beside-icon',
        tabBarStyle: {
          backgroundColor: '#0b4660',
          height: 90,
          borderTopWidth: 0,
          padding: 3,
        },
        tabBarLabelStyle: {
          fontFamily: 'IranSans',
          fontSize: 11.5, justifyContent: 'center', alignContent: 'center', alignItems: 'center', marginTop: 3
        },
        tabBarItemStyle: {

        },
        tabBarLabelPosition: 'below-icon'
      }} >
      <TabBtnNav.Screen name='hometab' component={Dashboard} options={{
        tabBarLabel: t('home')
        , tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./assets/icons/icon-home-click.png")} style={{ width: 55, height: 55 }} /> : <Image resizeMode="contain" source={require("./assets/icons/icon-home.png")} style={{ width: 50, height: 50 }} />)

      }} />
      <TabBtnNav.Screen name='calsimple' component={BorodatiSimple} options={{
        tabBarLabel: t('simplecalculation'),
        tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./assets/icons/icon-simple-cal-click.png")} style={{ width: 55, height: 55 }} /> : <Image resizeMode="contain" source={require("./assets/icons/icon-simple-cal.png")} style={{ width: 50, height: 50 }} />)
      }} />
      <Tab.Screen name='calpro' component={BorodatiPro} options={{
        tabBarLabel: t('advancedcalculation'),
        tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./assets/icons/iconpro-cal-click.png")} style={{ width: 55, height: 55 }} /> : <Image resizeMode="contain" source={require("./assets/icons/iconpro-cal.png")} style={{ width: 50, height: 50 }} />)
      }} />
      <TabBtnNav.Screen name='seldevice' component={SelectDevice} options={{
        tabBarLabel: t('selectdevice'),
        tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./assets/icons/icon-sel-device-click.png")} style={{ width: 55, height: 55 }} /> : <Image resizeMode="contain" source={require("./assets/icons/icon-sel-device.png")} style={{ width: 50, height: 50 }} />)
      }} />
      <TabBtnNav.Screen name='navmenu' component={MenuNav} options={{
        tabBarLabel: t('aboutus'),
        tabBarIcon: (tabInfo) => (tabInfo.focused ? <Image resizeMode="contain" source={require("./assets/icons/icon-menu-click.png")} style={{ width: 55, height: 55 }} /> : <Image resizeMode="contain" source={require("./assets/icons/icon-menu.png")} style={{ width: 50, height: 50 }} />)
      }} />

    </TabBtnNav.Navigator>
  )
}

const loadFont = () => {
  return Font.loadAsync({
    IranSans: require('./assets/fonts/IRANSansWeb.ttf')
  })
}
function LogoTitle() {
  return (


    <Image
      style={{ width: 120, height: 70, resizeMode: 'contain', }}
      source={require('./assets/logonew.png')}
    />

  );
}
const DashboardStack = (props) => {


  return (
    <Stack.Navigator
      screenOptions={{
        title: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />,
        headerTitleAlign: 'center',
        headerTintColor: '#fff',
        headerStyle: { backgroundColor: "#0b4660", borderWidth: 0, borderBottomWidth: 0 }
      }}

    >

      <Stack.Screen name='Dashboards' component={TabBottomFunc} options={{
        headerLeft: () =>
          <TouchableOpacity style={{ marginLeft: 12 }} onPress={() => props.navigation.navigate('ChatMe')}>
            <Icon name={'comments'} size={24} color={"white"} />
          </TouchableOpacity>

      }
      }

      />
      <Stack.Screen name='Products' component={Products} options={{ headerTitle: "محصولات" }} screenOptions={{ headerLeft: () => <Text>hello</Text> }} />
      <Stack.Screen name='ProductsDetail' component={ProductDetail} options={{ headerTitle: "جزئیات محصول" }} />
      <Stack.Screen name='BlogDetail' component={BlogDetail} options={{ headerTitle: "مقالات" }} />
      <Stack.Screen name='GalleryDetail' component={GalleryDetail} options={{ headerTitle: "گالری" }} />
      <Stack.Screen name='Blogs' component={Blogs} options={{ headerTitle: "مقالات" }} />
      <Stack.Screen name='Request' component={Request} options={{ headerTitle: "سفارش" }} />
      <Stack.Screen name='CustomerVoice' component={CustomerVoice} options={{ headerTitle: "صدای مشتری" }} />
      <Stack.Screen name='Boomrang' component={BorodatiSimpleTab} options={{ headerTitle: "" }} />
      <Stack.Screen name='Profile' component={Profile} options={{ headerTitle: "مشخصات من" }} />
      <Stack.Screen name='BorodatiSimple' component={BorodatiSimple} options={{ headerTitle: '' }} />
      <Stack.Screen name='BorodatiPro' component={BorodatiPro} options={{ headerTitle: '' }} />
      <Stack.Screen name='BorodatiResult' component={BorodatiResult} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }}
      />
      <Stack.Screen name='SelectDevice' component={SelectDevice} options={{ headerTitle: '' }} />
      <Stack.Screen name='Projects' component={Projects} options={{ headerTitle: "پروژه ها" }} />
      <Stack.Screen name='Gallery' component={Gallery} options={{ headerTitle: '' }} />
      <Stack.Screen name='ChatMe' component={LiveChat} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ResultBorodatiSimple' component={ResultBorodatiSimple} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_Evaprator' component={SelectDevice_Evaprator} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}

        />

      }} />
      <Stack.Screen name='ُSelectDevice_CondO45' component={SelectDevice_CondO45} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_CondA45' component={SelectDevice_CondA45} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_EvapratorArtec' component={SelectDevice_EvapratorArtec} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_EvapratorChandMedareh' component={SelectDevice_EvapratorChandMedareh} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_CondO8' component={CondO8ByCalculate} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_CondA8' component={CondA8ByCalculate} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='ُSelectDevice_CondArtec' component={SelectDevice_CondArtec} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='SearchEvaprator' component={Search_Evaprator} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='CondenserResult' component={ResultCondenser} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
       <Stack.Screen name='EvapratorResult' component={ResultEvaprator} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='CompEvaprator' component={CompEvaprator} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
      <Stack.Screen name='CompCondonser' component={CompCondonser} options={{
        headerTitle: <Image
          style={{ width: 120, height: 70, resizeMode: 'contain', }}
          source={require('./assets/logonew.png')}
        />
      }} />
    </Stack.Navigator>
  )
}


SplashScreen.preventAutoHideAsync();

const App = (props) => {
  const { t, i18n } = useTranslation();
  const [appIsReady, setAppIsReady] = useState(false);

  useEffect(() => {
    async function prepare() {
      try {
        await new Promise(resolve => setTimeout(resolve, 20000));
      } catch (e) {
        console.warn(e);
      } finally {
        setAppIsReady(true);
      }
    }

    prepare();
  }, []);


  const onLayoutRootView = useCallback(async () => {
    if (appIsReady) {
      await SplashScreen.hideAsync();
    }
  }, [appIsReady]);





  const MyTheme = {
    colors: {
      background: '#ebecec',
      border: '#ebecec',
    },
  };
  const [loadedData, setLoadedData] = useState(false);
  if (!loadedData) {
    return (<AppLoading startAsync={loadFont} onFinish={() => setLoadedData(true)} onError={console.warn} />)
  }

  if (!appIsReady) {
    return (
      <SafeAreaView style={{ backgroundColor: '#08598e', width: '100%', height: '100vh', flex: 1, flexDirection: 'column', alignItems: 'center' }}>
        <View style={{ position: 'absolute', top: 30, flex: 1, alignItems: 'center' }}>
          <Image
            style={{ width: 180, height: 42, resizeMode: 'contain' }}
            source={require('./assets/logonew.png')}
          />
        </View>
        <View style={{
          justifyContent: 'center',
          alignItems: 'center', flex: 1, width: '100%'
        }}>
          <Image
            style={{ width: '70%', height: 161, resizeMode: 'contain', }}
            source={require('./assets/logotext.png')}
          />
        </View>
        <View style={{ position: 'absolute', bottom: 10, flex: 1, alignItems: 'center' }}>

          <TouchableOpacity onPress={() => {
            i18n.changeLanguage("en");
            setAppIsReady(true);
          }}>
            <Image
              style={{ width: 80, height: 31, resizeMode: 'contain' }}
              source={require('./assets/enbtn.png')}
            />
          </TouchableOpacity>
          <Image
            style={{ width: 300, height: 14, resizeMode: 'contain' }}
            source={require('./assets/linesplash.png')}
          />
          <TouchableOpacity onPress={() => {
            i18n.changeLanguage("fa");
            setAppIsReady(true);
          }}>
            <Image
              style={{ width: 80, height: 31, resizeMode: 'contain', marginBottom: 20 }}
              source={require('./assets/fabtn.png')}
            />
          </TouchableOpacity>
          <Image
            style={{ width: 100, height: 35, resizeMode: 'contain' }}
            source={require('./assets/version.png')}
          />

        </View>


      </SafeAreaView>
    );
  }



  return (


    <NavigationContainer theme={MyTheme} onLayout={onLayoutRootView}>

      <Drawer.Navigator
        screenOptions={{
          activeTintColor: '#e91e63',
          itemStyle: { marginVertical: 5 },
        }}
      >
        <Drawer.Screen name='Dashboard' component={DashboardStack} options={{ headerShown: false }} />
      </Drawer.Navigator>
    </NavigationContainer>


  );
}
export default App;
